import React from 'react';
import ContentLoader from 'react-content-loader';
import PropTypes from 'prop-types';
import * as Styled from './Rectangle.Skeleton.styles';

var RectangleSkeleton = function RectangleSkeleton(_ref) {
  var height = _ref.height,
      width = _ref.width,
      speed = _ref.speed,
      primaryColor = _ref.primaryColor,
      secondaryColor = _ref.secondaryColor;
  return /*#__PURE__*/React.createElement(Styled.Wrapper, null, /*#__PURE__*/React.createElement(ContentLoader, {
    viewBox: "0 0 ".concat(width, " ").concat(height),
    speed: speed,
    backgroundColor: primaryColor,
    foregroundColor: secondaryColor
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    rx: "3",
    ry: "3",
    width: width,
    height: height
  })));
};

RectangleSkeleton.propTypes = {
  /**
   * Optional prop for the height
   */
  height: PropTypes.number,

  /**
   * Optional prop for the width
   */
  width: PropTypes.number,

  /**
   * Optional prop for the speed of the gradient
   */
  speed: PropTypes.number,

  /**
   * Optional prop for the primary colour for the gradient
   */
  primaryColor: PropTypes.string,

  /**
   * Optional prop for the secondary colour for the gradient
   */
  secondaryColor: PropTypes.string
};
RectangleSkeleton.defaultProps = {
  height: 200,
  width: 200,
  speed: 1,
  primaryColor: '#f3f3f3',
  secondaryColor: '#ecebeb'
};
export default RectangleSkeleton;